import { Component } from '@angular/core'

@Component({
  selector: 'app-refresh-reports',
  standalone: true,
  imports: [],
  templateUrl: './refresh-reports.component.html',
  styleUrl: './refresh-reports.component.css',
})
export class RefreshReportsComponent {}
